import type { WidgetVariant } from "@/types";

export const IGW_BUTTON_ID = "unibo-igw-button";
export const IGW_NOTIFICATION_ELEMENT_ID = "unibo-igw-notifications";

const OSW_CUSTOM_PREFIX = "unibo-osw-custom-";
const OSW_PATTERN = /^unibo-osw-custom-\d+$/;

// Delegated click lookup: returns the trigger element if `target` (or any
// ancestor) is a trigger button, or null. Lets host pages mount trigger
// buttons after DOMContentLoaded without needing a rescan API.
export function matchTriggerButton(
  target: EventTarget | null,
  variant: WidgetVariant
): HTMLElement | null {
  if (!(target instanceof Element)) return null;

  if (variant === "in-game") {
    return target.closest<HTMLElement>(`#${IGW_BUTTON_ID}`);
  }

  const el = target.closest<HTMLElement>(`[id^="${OSW_CUSTOM_PREFIX}"]`);
  return el && OSW_PATTERN.test(el.id) ? el : null;
}
